import { z } from 'zod';
export const planOfCare485ValidationSchema = z.object({
    id: z.string(),
    data: z.object({
        General: z.object({
            primaryPhysician: z.string().min(1, 'required'),
            primaryCaregiver: z.string().nullish(),
        }),
        PlanOfCare: z.boolean().refine((value) => !!value, { message: 'section has errors' }),
        Medications: z.boolean(),
        HomeboundReason: z.object({
            homeboundReasonA: z.string().nullish(),
            homeboundReasonB: z.string().nullish(),
            homeboundReasonC: z.string().nullish(),
        }),
        AbilityLimitation: z.object({
            rehabPotential: z.object({
                A: z.string().nullish(),
                B: z.string().nullish(),
                C: z.string().nullish(),
                D: z.string().nullish(),
            }),
            prognosis: z.string().nullish(),
            functionalLimitation: z.array(z.string()).optional(),
            functionalLimitationOther: z.string().nullish(),
            activitiesPermitted: z.array(z.string()).optional(),
            activitiesPermittedOther: z.string().nullish(),
        }),
        Hospitalization: z.object({
            risks: z.array(z.string()).optional(),
            risksOther: z.string().nullish(),
            necessaryInterventions: z.array(z.string()).optional(),
        }),
        MentalStatus: z
            .object({
            wnl: z.boolean().optional(),
            alertness: z.string().optional(),
            orientedToPerson: z.string().optional(),
            orientedToPlace: z.string().optional(),
            orientedToPurpose: z.string().optional(),
            orientedToTime: z.string().optional(),
            status: z.array(z.string()).optional(),
        })
            .refine((data) => data.wnl ||
            data.alertness ||
            data.orientedToPerson ||
            data.orientedToPlace ||
            data.orientedToPurpose ||
            data.orientedToTime ||
            data.status?.length, {
            message: 'Mark as within normal limits if none applies',
            path: [],
        }),
        Supplies: z.boolean(),
        Safety: z.object({
            safetyMeasures: z.array(z.string()).optional(),
            ambulateLocation: z.string().nullish(),
        }),
        NutritionAllergies: z.object({
            nutritionalRequirements: z.array(z.string()).optional(),
            nutritionalRequirementsOther: z.string().nullish(),
            tubeFeeding: z.boolean().nullish(),
            tubeFeedingFreq: z.string().nullish(),
            allergies: z.array(z.object({ allergy: z.string(), severity: z.string() })),
        }),
        DisciplineOrders: z.object({
            sn: z
                .object({
                frequency: z.string().optional(),
                prnVisits: z.string().optional(),
                ptRefused: z.boolean().optional(),
                tasks: z.array(z.string()).optional(),
                medicationName: z.string().optional(),
                other: z.string().optional(),
            })
                .refine((data) => data.frequency || data.prnVisits || data.ptRefused || data.tasks, {
                message: "Check 'Patient refused SN Services' if none applies",
                path: [],
            }),
            ha: z
                .object({
                frequency: z.string().optional(),
                ptRefused: z.boolean().optional(),
                tasks: z.array(z.string()).optional(),
                reportChangesOther: z.string().optional(),
            })
                .refine((data) => data.frequency || data.tasks || data.ptRefused, {
                message: "Check 'Patient refused HHA Services' if none applies",
                path: [],
            }),
            msw: z
                .object({
                frequency: z.string().optional(),
                ptRefused: z.boolean().optional(),
            })
                .refine((data) => data.frequency || data.ptRefused, {
                message: "Check 'Patient refused MSW Services' if none applies",
                path: [],
            }),
            pt: z
                .object({
                frequency: z.string().optional(),
                ptRefused: z.boolean().optional(),
            })
                .refine((data) => data.frequency || data.ptRefused, {
                message: "Check 'Patient refused PT Services' if none applies",
                path: [],
            }),
            ot: z
                .object({
                frequency: z.string().optional(),
                ptRefused: z.boolean().optional(),
            })
                .refine((data) => data.frequency || data.ptRefused, {
                message: "Check 'Patient refused OT Services' if none applies",
                path: [],
            }),
            slp: z
                .object({
                frequency: z.string().optional(),
                ptRefused: z.boolean().optional(),
                tasks: z.array(z.string()).optional(),
            })
                .refine((data) => data.frequency || data.tasks || data.ptRefused, {
                message: "Check 'Patient refused SLP Services' if none applies",
                path: [],
            }),
            advanceDirectives: z.object({
                livingWill: z.string().min(1, 'required'),
                dnr: z.string().min(1, 'required'),
                surrogate: z.string().min(1, 'required'),
                copyObtained: z.string().min(1, 'required'),
            }),
        }),
        GeneralOrders: z.object({
            order: z.string().optional(),
        }),
    }),
    signedUserId: z.string().min(1, 'required'),
    signedUserDate: z.string().min(1, 'required'),
});
